import { AuthService } from "./AuthService";
import { DomainService } from "./DomainService";
const baseUrl = DomainService.GetBaseUrl() +"Auth/";

const Login = async (loginId, password,userTypeID) => {
    const item ={
        LoginId: loginId,
        Password: password,
        UserTypeID:userTypeID
    }
    const res = await fetch(baseUrl + "Login", {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
        body: JSON.stringify(item)
    });
    const data = await res.json();
    return data;
}
const ResetLogin = async(currentUserID) => {

    const res = await fetch(baseUrl + "ResetUserLogin?currentUserID="+currentUserID, {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
    });
    const data = await res.json();
    return data;
}
const changeUserPassword = async (oldPassword, newConfirmPassword) => {

    const item = {
        UserID: parseInt(AuthService.getCurrentUser().userId),
        OldPassword: oldPassword,
        NewPassword: newConfirmPassword
    }

    const res = await fetch(baseUrl + "Changepassword", {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(item)
    });
    const data = await res.json();
    return data;
}

export const UserService = {
    Login,
    ResetLogin,
    changeUserPassword
}
